import React, { useEffect, useRef, useCallback, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Alert, Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import NumberInput from '../Input/NumberInput';
import ButtonAction from '../Button.js/SaveButton';
import Loader from '../loader/loader';
import ConfirmDeviceModal from './ConfirmDeviceModal';
import ComboboxImage from '../Input/ComboboxImage';
import ComboBox from '../Input/ComboBox';
import TextInput from '../Input/TextInput';
import ChessBoard from '../ChessBoard/ChessBoard';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const CheckingHardware = ({
    dataDrawer = [],
    idCabinet,
    isReload = true,
    visible = false,
    dataUpdate,
    setVisible,
    idPermission,
    fuctGet,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [cabinet, setcabinet] = useState(null);
    const [dataCabinet, setDataCabinet] = useState([]);
    const [row, setRow] = useState('1');
    const [column, setColumn] = useState('1');
    const [location, setLocation] = useState('1');
    const [open, setOpen] = useState(false);

    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const openRef = useRef(false);

    useEffect(() => {
        if (openRef.current) {
            window.addEventListener('beforeunload', handleBeforeUnload);
            window.addEventListener('unload', handleBeforeUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleBeforeUnload);
        };
    }, []);

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    };

    useEffect(() => {
        // console.log('CheckingHardware');
        // console.log('dataDrawer: ', dataDrawer);
        dataDrawer.length > 0 &&
            setcabinet({
                drawer_nm: dataDrawer[0]?.drawer_nm,
                id: dataDrawer[0]?.id,
                drawer_lc: dataDrawer[0]?.drawer_lc,
                cabinet_cd: dataDrawer[0]?.cabinet_cd,
                cabinet_type: dataDrawer[0]?.cabinet_type,
                cells_x: dataDrawer[0]?.cells_x, //Tổng số ô dành cho tủ tròn
            });
    }, [dataDrawer]);

    const openCell = (data) => {
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        actionRef.current = true;
        // console.log([data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column]);
        let service = serviceList.openCellIOT;
        let inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +row, +column];
        if (cabinet?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +row, +column];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +location, +cabinet.cells_x];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 40000, 0);
        // console.log('inpuVal: ', inpuVal);
        // console.log('serviceList: ', service);
    };

    const openCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            openRef.current = false;
            toast.error('Error: ' + message['proc_message']);
        } else {
            setOpen(true);
            openRef.current = true;
        }
    };
    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        toast.error(t('error.time_out') + ' IOT');
        // closeCell();
    };

    const closeCell = () => {
        openRef.current = false;
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        actionRef.current = true;

        let service = serviceList.closeCellIOT;
        let inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +row, +column];
        if (cabinet?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +row, +column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [cabinet.cabinet_cd, cabinet.drawer_lc, +location, +cabinet.cells_x];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 40000, 0);
        // console.log("===Close Cell", inpuVal)
        // sendRequest(
        //     serviceList.closeCellIOT,
        //     [cabinet.cabinet_cd, cabinet.drawer_lc, +row, +column],
        //     closeCellResult,
        //     true,
        //     timeOutFunctIOT,
        //     40000,
        //     0
        // );
    };
    const closeCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setOpen(false);
        }
    };

    return (
        <BootstrapDialog fullScreen={fullScreen} open={visible} aria-labelledby="customized-dialog-title">
            <Loader loading={actionDeviceOnline} />
            <BootstrapDialogTitle id="customized-dialog-title">{t('checking_hardware')} </BootstrapDialogTitle>
            <DialogContent dividers sx={{ minWidth: 400 }}>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('choose_drawer')}
                            getValue={setcabinet}
                            valueSelect={cabinet}
                            valueEqual="id"
                            selectOption={dataDrawer}
                            displayLabel="drawer_nm"
                            autoFocus
                        />
                    </Grid>
                    {cabinet?.cabinet_type !== 'round' ? (
                        <>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <NumberInput
                                    label={t('row')}
                                    sizeCbb="medium"
                                    valueChange={row}
                                    disabled={cabinet?.id ? false : true}
                                    required
                                    getValue={setRow}
                                />
                            </Grid>
                            <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                                <NumberInput
                                    label={t('column')}
                                    sizeCbb="medium"
                                    valueChange={column}
                                    disabled={cabinet?.id ? false : true}
                                    required
                                    getValue={setColumn}
                                />
                            </Grid>
                        </>
                    ) : (
                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                            <NumberInput
                                label={t('Vị trí ô')}
                                sizeCbb="medium"
                                valueChange={location}
                                disabled={cabinet?.id ? false : true}
                                required
                                getValue={setLocation}
                            />
                        </Grid>
                    )}
                    {cabinet?.cabinet_type !== 'round' && (
                        <ChessBoard
                            rows={cabinet?.cells_y ? cabinet?.cells_y : dataDrawer[0]?.cells_y}
                            columns={cabinet?.cells_x ? cabinet?.cells_x : dataDrawer[0]?.cells_x}
                            activePosition={{
                                row: +row,
                                column: +column,
                            }}
                            typeCabinet={cabinet?.cabinet_type}
                        />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => setVisible(!visible)}
                    disabled={open}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction onClick={openCell} disabled={open} type={'confirm'} title={t('open') + ' ' + t('cell')} />
                <ButtonAction
                    onClick={closeCell}
                    disabled={!open}
                    type={'confirm'}
                    title={t('close') + ' ' + t('cell')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CheckingHardware;
